import { Fragment, useState } from "react";
import {
  Box,
  Drawer,
  AppBar,
  CssBaseline,
  Toolbar,
  List,
  Collapse,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  CardMedia,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { Inbox, Logout, Mail, PersonAdd, Settings } from "@mui/icons-material";
import Colors from "../assets/styles";
import Images from "../assets/images";
import dashboardNav from "./Navigation";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { DropdownIcon } from "../assets/icons";
import "@fontsource/open-sans";
import ListMenu from "../components/menu";
import useAuth from "../hooks/useAuth";
import AuthServices from "../apis/AuthServices";
import PersonIcon from "@mui/icons-material/Person";
import { baseUrl } from "../config/axios";
import moment from "moment";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const drawerWidth = 250;

function Layout() {
  const [expanded, setExpanded] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(null);
  const open = Boolean(isMenuOpen);
  const { userLogout, user } = useAuth();

  const handleMenu = (event) => {
    setIsMenuOpen(event.currentTarget);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(null);
  };
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleExpandClick = (index) => {
    setExpanded((prevExpanded) => {
      if (prevExpanded === index) {
      
        return null;
      } else {
        // Expand the new index
        return index;
      }
    });
  };
  

  const handleLogout = async (opt) => {
    if (opt == "Log Out") {
      handleMenuClose();
      try {
        await AuthServices.logout({
          UserName: user?.UserName || user?.userName || "",
        });
      } catch (e) {
      }
      await userLogout();
      navigate("/login", { replace: true });
    } else if (opt == "Account Setting") {
      navigate("/account-setting");
    }
  };

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: "#133e02",
          py: "4px",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box sx={{display:'flex',alignItems:"center",gap:"10px"}}>
          <CardMedia
            component={"img"}
            src={Images.headerLogo}
            sx={{
              width: "35px",
              height: "35px",
              objectFit: "contain",
            }}
          />
          <Typography sx= {{color:Colors.white,fontSize:"26px",textTransform:"uppercase"}}>
            Pak Rail Live
          </Typography>

          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
            }}
          >
            <Box sx={{display:'flex',alignItems:'center',gap:1}}> 
              
            <Typography>{moment().format("HH:mm")} </Typography>
            <Typography>{moment().format("ddd Do MMM YYYY")}</Typography>
            </Box>
            <Box sx={{display:'flex',alignItems:'center',gap:'4px'}}>      
            <Avatar
              alt="Profile Image"
              sx={{
                width: "30px",
                height: "30px",
                img: { objectPosition: "top" },
              }}
              src={Images.user}
            />
            <Typography>{user?.UserName || user?.userName || "User"}</Typography>
            <IconButton onClick={handleMenu}>
              <DropdownIcon />
            </IconButton>
            <ListMenu
              open={open}
              anchorEl={isMenuOpen}
              onClose={handleMenuClose}
              options={[
                {
                  label: "Log Out",
                  icon: <Logout />,
                }
              ]}
              onClick={(opt) => handleLogout(opt)}
            />
                </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            background: Colors.body,
            borderRight: `1px solid ${Colors.white + "1A"}`,
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 3px 8px"
          },
        }}
      >
        <Toolbar sx={{ py: "50px" }} />
        <Box sx={{ overflow: "auto" }}>
          <List
            sx={{
             
              py: "28px",
              display: "flex",
              flexDirection: "column",
              gap: 2, 
            }}
          >
          {dashboardNav.map((item, index) => (
  <Fragment key={index}>
    <ListItem disablePadding>
      <ListItemButton
        sx={{
          gap: 1,
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => {
          if (item.subMenu) {
            handleExpandClick(index);
            navigate(item.path);
          } else {
            navigate(item.path);
            handleExpandClick(null);
          }
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: "30px",
            color:
              pathname === item.path ||
              (item.subMenu && expanded === index)
                ? "rgb(19 62 2)"
                : Colors.black + "B3",
          }}
        >
          {item?.icon}
        </ListItemIcon>

        <ListItemText
          primary={item.name}
          sx={{
            ".MuiTypography-root": {
              fontFamily: "Open Sans",
              fontSize: "16px",
              fontWeight: 500,
              color:
                pathname === item.path
                  ? "rgb(19 62 2)"
                  : Colors.black + "B3",
            },
          }}
        />

        {/* Render the expand/collapse icon only if there is a submenu */}
        {item.subMenu && (
          expanded === index ? (
            <ExpandLess sx={{ color: "rgb(19 62 2)" }} />
          ) : (
            <ExpandMore sx={{ color: Colors.black + "B3" }} />
          )
        )}
      </ListItemButton>
    </ListItem>

    {/* Render submenu items */}
    {item.subMenu &&
      item.subMenu.map((subItem) => (
        <Collapse
          key={subItem.name}
          in={expanded === index}
          timeout="auto"
          unmountOnExit
        >
          <List sx={{ py: "0 !important", gap: "8px !important" }}>
            <ListItem disablePadding sx={{ py: "0 !important" }}>
              <ListItemButton
                onClick={() => navigate(subItem.path)}
                sx={{
                  gap: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: "30px",
                    color:
                      pathname === subItem.path
                        ? "rgb(19 62 2)"
                        : Colors.black + "B3",
                  }}
                >
                  {subItem.icon}
                </ListItemIcon>

                <ListItemText
                  primary={subItem.name}
                  sx={{
                    ".MuiTypography-root": {
                      fontFamily: "Open Sans",
                      fontSize: "16px",
                      fontWeight: 500,
                      color:
                        pathname === subItem.path
                          ? "rgb(19 62 2)"
                          : Colors.black + "B3",
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </Collapse>
      ))}
  </Fragment>
))}

          </List>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Toolbar sx={{ py: "50px" }} />
        <Box sx={{ p: "0 24px", height: "calc(100% - 100px)" }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default Layout;
